import { useContext } from "react";

import EpisodeContext from "@/containers/Episode/context";
import TextButton from "@components/TextButton";
import Typography from "@components/Typography";

import styles from "./UndoRemovedMention.module.css";

const UndoRemovedMention = ({ currentId }: { currentId: string }) => {
  const { undoRemoveMention } = useContext(EpisodeContext);

  return (
    <>
      <Typography
        variant="subtitle-2"
        className={styles.regretIndividualButton}
      >
        {L.MENTIONS_UNDO_INDIVIDUAL}
        <TextButton
          onClick={() => undoRemoveMention([currentId])}
          data-testid="remove-mention-undo"
        >
          {L.MENTIONS_MARKED_AS_IRRELEVANT_REVERT}
        </TextButton>
      </Typography>
    </>
  );
};

export default UndoRemovedMention;
